import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import { DateFormatTimeZone as DateFormat, checkPermissions } from 'hooks';
import PageSpinner from 'components/PageSpinner';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import { Link } from 'react-router-dom';
import { Input, Button, Form, FormGroup, FormFeedback } from 'reactstrap';
import PopupWindow from 'components/ModalPopup';
import { MdNotInterested } from 'react-icons/md';



const campaignStatus = ['Pending', 'Approved', 'Declined', 'Running', 'Paused', 'Completed'];
class CampaignList extends React.Component {

    constructor (props) {
        super(props);
        this.state = {
            campaignsList: [],
            statusPopup: false,
            declinePopup: false,
            declineReason: null,
            declineError: false,
            pagination: {
                page: 0,
                page_limit: 10,
            },
            selectedCampaign: {
                id: null,
                status: null
            },
            order: {
                order_by: `created_at`,
                direction: 'desc'
            },

        }
    }

    fetchCampaigns = () => {
        
        let filters = {
            userId: this.props.userId,
            ad_name: (this.props.filter)?this.props.filter.ad_name:undefined,
            keyword: (this.props.filter)?this.props.filter.keyword:undefined,
            page: this.state.pagination.page,
            page_limit: this.state.pagination.page_limit,
            order_by: this.state.order.order_by,
            direction: this.state.order.direction,
            capnStatus: (this.props.filter)?this.props.filter.capnStatus:undefined,
            
            start_date: (this.props.filter)?this.props.filter.start_date:undefined,
            end_date: (this.props.filter)?this.props.filter.end_date:undefined,
            isApproved: (this.props.filter)?this.props.filter.isApproved:undefined,
            deleted: (this.props.filter)?this.props.filter.deleted:undefined
            
        };

        this.props.getCampaigns(filters);
    }

    componentDidMount() {
        this.fetchCampaigns()
    }

    handleSubmit = () => {
        let selectedCampaign = this.state.selectedCampaign;
        
        if (selectedCampaign.status === 'Declined') {

            this.setState({ statusPopup: false })
            this.setState({ declinePopup: true })
        } else {
            this.props.changeStatus(this.state.selectedCampaign);
        }


    }

    handleStatus = (id, status, declined_reason) => {
        this.setState({ declineReason: declined_reason })
        this.setState({ selectedCampaign: { id, status } })
        this.setState({ statusPopup: true })
    }

    componentWillReceiveProps(newProps) {
        if (this.props.campaign !== newProps.campaign) {
            console.log(" New Props have been assigned ");

        }
        if (this.props.statusUpdated !== newProps.statusUpdated) {
            this.setState({ statusPopup: false })
            this.setState({ declinePopup: false })
            this.fetchCampaigns()

        }
        
    }

    render() {
        const options = {
            tableId: 'datatable',
            filterType: 'checkbox',
            search: false,
            responsive: "simple",
            filter: false,
            download: false,
            print: false,
            selectableRows: 'none',
            viewColumns: false,
            count: this.props.totalCount,
            serverSide: (this.props.serverSide !== undefined) ? this.props.serverSide : true,
            page: this.state.pagination.page,
            rowsPerPage: this.state.pagination.page_limit,
            onColumnSortChange: (changedColumn) => {
                this.setState({
                    order: {
                        order_by: changedColumn,
                        direction: (this.state.order.direction === 'asc') ? 'desc' : 'asc'
                    }
                },() => {
                    this.fetchCampaigns();
                });
                
            },
            onTableChange: (action, tableState) => {
                
                switch (action) {
                    case 'changePage':
                        this.setState({
                            pagination: {
                                page_limit: this.state.pagination.page_limit,
                                page: tableState.page
                            }
                        },() => {
                            this.fetchCampaigns();
                        });
                        break;
                    case 'changeRowsPerPage':
                        this.setState({
                            pagination: {
                                page_limit: tableState.rowsPerPage,
                                page: 0,
                            }
                        },() => {
                            this.fetchCampaigns();
                        });
                        break;
                    default:
                        break
                }
            }
        };

        const columns = () => {
            const cols = [
                { name: "id", label: "Id" },
                { name: "ad_set_name", label: "Ad set name" },
                { name: "campaign_name", label: "Campaign Name" },
                { name: "creative_ad_title", label: "Ad Title" },
                { name: "created_at", label: "Created At" },
                { name: "ad_start", label: "Start Date" },
                { name: "ad_end", label: "End Date" },
                { name: "totalDuration", label: "Total Days" },
                { name: "running_status", label: "Status" },
                { name: "status", label: "Action" },
                { name: "total_ad_budget", label: "Total Budget" },
                
                //{ name: "goal", label: "Ad Stategy CPV/CPC" },
                { name: "id", label: "View Add" },
                { name: "decline_reason", label: "decline_reason" },

                { name: "spent_on_view", label: "spent_on_view" },
                { name: "spent_on_click", label: "spent_on_click" },

                { name: "today_spent", label: "today_spent" },
                { name: "cost_per_view", label: "cost_per_view" },
                { name: "per_day_budget", label: "Budget Per Day" },



            ];
            return cols.map((column, index) => {
                return {
                    label: column.label,
                    name: column.name,
                    options: {
                        display: (column.label === 'Budget Per Day' ||
                        column.label === 'today_spent' ||
                        column.label === 'cost_per_view' ||
                        column.label === 'Id' || column.label === 'decline_reason'
                            || column.label === 'spent_on_view' || column.label === 'spent_on_click') ? false : true,
                        customHeadRender: (columnMeta, updateDirection) => {
                            return <TableCustomHeader style={(column.label === 'Action')?{ textAlign:'center'}:null} key={index} itemkey={index} order={this.state.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                        },
                        setCellProps: () => ({
                            style: (column.label === 'Action')?{ textAlign:'center'}:null
                        }),
                        customBodyRender: (value, tableMeta, updateValue) => {
                            
                            if (tableMeta.columnData.name === 'ad_start' || tableMeta.columnData.name === 'ad_end' || tableMeta.columnData.name === 'created_at') {
                                return DateFormat(value, 'MM-DD-YYYY HH:mm:ss')
                            } else if (tableMeta.columnData.name === 'is_approved') {
                                return (value === 0) ? 'No' : "Yes";
                            }
                            else if (tableMeta.columnData.name === 'running_status') {
                                
                                return (
                                    <div>
                                        {value}
                                        {value === 'Completed' ?
                                        <div style={{fontSize:10, color:'#ff9900', textAlign:'center'}}>
                                            {
                                                (new Date().getTime() >= new Date(tableMeta.rowData[5]).getTime())? 'Duration' : 
                                                (tableMeta.rowData[9] < 1) ? 'Budget' : ''}
                                        </div>
                                        :(value === 'Running' && (parseInt(tableMeta.rowData[14])+parseInt(tableMeta.rowData[15])) >= tableMeta.rowData[16])?
                                        <div style={{fontSize:10, color:'#ff9900', textAlign:'left'}}>Per day budget exceed
                                        </div>
                                        :
                                        ''
                                    }
                                    </div>
                                )
                            }
                            else if (tableMeta.columnData.name === 'status') {
                                return (checkPermissions(this.props.loginData, 'campaign_status') && campaignStatus.includes(value)) ? <Button style={{ padding: '0px' }} color="link" onClick={() => this.handleStatus(tableMeta.rowData[0], value, tableMeta.rowData[11])}>{value}</Button> : <MdNotInterested style={{fontSize:18}}/>
                            } else if (tableMeta.columnData.label === 'View Add') {
                                return checkPermissions(this.props.loginData, 'campaign_details') ? <Link className={'view-profile-link'} to={`/campaign-details/${value}`}><Button color="primary" className="border-0" >View</Button></Link> : <Button color="primary" disabled={true} className="border-0 btn-disabled" >View</Button>
                            } else if (tableMeta.columnData.name === 'goal') {
                                return (value === 'impressions') ? 'CPV' : "CPC";
                            }
                            else {
                                return value;
                            }
                        }
                    }
                }
            })
        }
        let campaigndata = (this.props.campaign && this.props.campaign['usersCampaign-' + this.props.userId] && this.props.campaign['usersCampaign-' + this.props.userId].data) ? this.props.campaign['usersCampaign-' + this.props.userId].data : [];
        console.log('=====>', this.state.statusPopup)
        return (
            <div key={this.props.renderKey}>
                <PopupWindow hideButton={true}
                    buttonStyle={{ marginTop: 10, width: '100%' }}
                    handlePopup={(popup) => { this.setState({ statusPopup: popup }) }}
                    openWindow={this.state.statusPopup} title={'Change Status'}
                    launchButtonText={'Change Status'} >
                    <div>
                        <div style={{ display: 'flex' }}>
                            {(this.props.loading)?<PageSpinner style={{position:'absolute',height:'auto',zIndex:'999'}}/>:''}
                            <Form>
                                <Input onChange={(e) => {
                                    this.setState({
                                        selectedCampaign: {
                                            id: (this.state.selectedCampaign && this.state.selectedCampaign.id) ? this.state.selectedCampaign.id : null,
                                            status: e.target.value
                                        }
                                    });
                                }} className="mb-2" type="select" defaultValue={(this.state.selectedCampaign && this.state.selectedCampaign.status) ? this.state.selectedCampaign.status : ''} style={{ width: 200, display: 'inline' }}>
                                    <option value={0}>Select Group</option>
                                    {['Pending', 'Approved', 'Declined', 'Paused'].map((item) => (<option key={item} value={item}>{item}</option>))}
                                </Input> 
                                <Button onClick={this.handleSubmit} style={{ padding: 10, marginLeft: 20, verticalAlign: 'top' }} color="primary" size="lg" className="border-0" >Change</Button>
                            
                            </Form>

                        </div>
                    </div>
                </PopupWindow>

                <PopupWindow hideButton={true}
                    buttonStyle={{ marginTop: 10, width: '100%' }}
                    handlePopup={(popup) => { this.setState({ declinePopup: popup }) }}
                    openWindow={this.state.declinePopup} title={'Decline Reason'}
                    launchButtonText={'Change Status'} >
                    <div>
                        <div style={{ display: 'flex' }}>
                        {(this.props.loading)?<PageSpinner style={{position:'absolute',height:'auto',zIndex:'999'}}/>:''}
                            <Form style={{ width: '100%' }}>
                                <FormGroup>
                                    <Input
                                        value={this.state.declineReason}
                                        onChange={(e) => {
                                            this.setState({ declineReason: e.target.value })
                                        }
                                        }
                                        type="textarea" name="text" id="exampleText" style={{ width: '100%' }}
                                    />
                                </FormGroup>
                                {(this.state.declineError && !this.state.declineReason) && <FormGroup><FormFeedback >Please add a reason</FormFeedback></FormGroup>}
                                <Button onClick={() => {
                                    if (!this.state.declineReason) {
                                        this.setState({ declineError: true })
                                    } else {
                                        let selectedCampaign = { ...this.state.selectedCampaign };
                                        selectedCampaign['decline_reason'] = this.state.declineReason;
                                        this.props.changeStatus(selectedCampaign);

                                    }
                                    
                                }} color="primary" size="lg" className="border-0" >Decline</Button>
                            </Form>

                        </div>
                    </div>
                </PopupWindow>
                {(this.props.isLoading && this.props.isLoading.page === `USER-CAMPAIGN-${this.props.userId}`) ? <PageSpinner><DataTables data={campaigndata} columns={columns()} options={options} /></PageSpinner>
                    : <DataTables data={campaigndata} columns={columns()} options={options} />
                }
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    loading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer['PAGE-LOADING']) ? state.uiReducer['PAGE-LOADING'] : null,
    campaign: (state.campaign) ? state.campaign : null,
    totalCount: (state.campaign &&
        state.campaign['usersCampaign-' + props.userId] && state.campaign['usersCampaign-' + props.userId].totalCampaigns) ? state.campaign['usersCampaign-' + props.userId].totalCampaigns : 0,
    statusUpdated: (state.campaign && state.campaign.statusUpdated) ? state.campaign.statusUpdated : undefined,
    uiReducer: (state.uiReducer)
});
const mapDispatchToProps = (dispatch) => ({
    getCampaigns: (payload) => dispatch(CampaignAction.getCampaigns(payload)),
    changeStatus: (payload) => dispatch(CampaignAction.changeStatus(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignList);
